<template>
  <wo-card :title="modalTitle">
    <wo-region>
      <wo-layout>
        <slot>
          <wo-typography>{{ modalMessage }}</wo-typography>
        </slot>
      </wo-layout>
    </wo-region>
    <wo-region>
      <wo-layout class="wo-u-align-right">
        <po-promise-button v-focus="true" label-key='general.action.ok' @click="confirmed" />
      </wo-layout>
    </wo-region>
  </wo-card>
</template>
<script>

import modal from '@/mixins/modal'

export default {
  mixins: [modal],
  props: {
    titleKey: { type: String, default: 'general.informationTitle' },
    messageKey: String,
    message: String,
    code: String
  },
  computed: {
    modalTitle () {
      return this.$t(this.titleKey)
    },
    modalMessage () {
      return this.message || this.$t(this.messageKey)
    }
  },
  methods: {
    confirmed () {
      this.close()
    }
  }
}
</script>
